import Logo from './logo.svg'
import PrintLogo from './print-logo.svg'
import CoverImage from './report_cover.png'
import { HomePage } from './HomePage'
import { PrivacyPage } from './PrivacyPage'
import { TermsPage } from './TermsPage'
import { ValuesPage } from './ValuesPage'
import { ThemesPage } from './ThemesPage'
import { TitlesPage } from './TitlesPage'
import { themeData } from './themeData'
import { NextStepsPage } from './NextSteps'
import Favicon from './favicon.ico'
import CongratsImage from './Congratulations - Last Assessment Page 1080x1350.svg'

export default {
    favicon: Favicon,
    site: 'workforce',
    brandName: 'Job Passion',
    brandNameFull: 'Job Passion Assessment',
    displayDemographics: true,
    displayNextSteps: true,
    displayJobs: false,
    Logo: Logo,
    PrintLogo,
    CoverImage,
    HomePage,
    SignupPage: null,
    PrivacyPage,
    TermsPage,
    ValuesPage,
    ThemesPage,
    TitlesPage,
    NextStepsPage,
    themeData,
    CongratsImage
}